<template>
    <!--        Button Group -->
    <div class="col-4 ml-auto d-flex flex-row justify-content-end">
        <div class="btn-group mt-3"
             role="group">
            <!--            Button Edit -->
            <slot name="before"></slot>

            <button
                v-if="!disableEdit"
                :disabled="isLoading"
                class="btn btn-sm btn-info"
                type="button"
                @click="$emit('edit', true)">Bearbeiten <i class="fas fa-pen"></i></button>

            <slot name="center"></slot>

            <!--            Button Delete -->
            <button
                v-if="!disableDelete"
                :disabled="isLoading"
                class="btn btn-sm btn-danger"
                type="button"
                @click="$emit('delete')">Löschen <i v-if="!isLoading" class="fas fa-trash"></i><i
                v-if="isLoading" class="fas fa-spinner fa-spin"></i></button>

            <slot name="after"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Buttons',
    props: {
        isLoading: Boolean,
        disableEdit: false,
        disableDelete: false,
    },
};
</script>
